import axios from '@/utils/axiosInt.js'
export default {
  //获取全国热力图
  getTop150Road1(roadType, cityCode, id) {
    return axios.get(
      `/bi-api/shell/top150Road?roadType=${roadType}&cityCode=${cityCode}&id=${id}`
    )
  },
  //获取全国热力图
  getTop150Road(option) {
    return axios.post(
      `/bi-api/shell/top150Road`,
      option
    )
  },
  //获取热门城市热力图
  getTop30CityRoad(option, isAll) {
    if (isAll) {
      return axios.post(
        `/bi-api/shell/top30CityRoad`,
        option
      )
    } else {
      return axios.post(
        `/bi-api/shell/top150Road`,
        option
      )
    }
  },
  // ?roadType=${option.roadType}&cityCode=${option.cityCode}&roadIds=${option.roadIds}
  // 获取20个城市
  getTop20City() {
    return axios.get(
      `/bi-api/shell/top20City`
    )
  },
  // 全国热力图详情
  getRoadDetails(id, cityName) {
    return axios.get(
      `/bi-api/shell/passFlowPerDayOfRoad?id=${id}&cityName=${cityName}`
    )
  },
  // 热区详情
  getHCityDetails(code) {
    return axios.get(
      `/bi-api/shell/passFlowPerDayOfCity?cityCode=${code}`
    )
  },
  // 新建站点
  addSite(option) {
    return axios.post(
      '/bi-api/shell/addSite',
      option
    )
  },
  addGeom(option) {
    return axios.post(
      '/bi-api/shell/addGeom',
      option
    )
  },
  // /
  // 修改站点
  modifySide(option) {
    return axios.post(
      '/bi-api/shell/modifySite',
      option
    )
  },
  // 删除站点
  deleteSide(option) {
    return axios.post(
      '/bi-api/shell/deleteSite',
      option
    )
  },
  //查询单个站点
  getSide(id) {
    return axios.post(
      `/bi-api/shell/getSite?id=${id}`
    )
  },
  // 查询站点列表
  getListSide(data) {
    return axios.post(
      '/bi-api/shell/listSite',
      data
    )
  },
  // 全部道路
  getAllRoad(roadNo,roadType) {
    return axios.get(
      `/bi-api/shell/allRoad?roadNo=${roadNo}&roadType=${roadType}`
    )
  },
  // 全部城市
  getAllRoadCity(id, cityName) {
    return axios.get(
      `/bi-api/shell/allRoadCity?id=${id}&cityName=${cityName}`
    )
  },
}
